// src/config/websocketConfig.ts
/* Small helper to pick the correct WebSocket URL at build time */

const FALLBACK_DEV_URL =
  'wss://v9ok925lv4.execute-api.us-east-2.amazonaws.com/dev';

export const WEBSOCKET_URL =
  import.meta.env.VITE_WEBSOCKET_URL || // preferred (demo/prod/dev)
  import.meta.env.VITE_API_WEBSOCKET || // legacy var while migrating
  FALLBACK_DEV_URL; // last-resort dev default

if (
  !import.meta.env.VITE_WEBSOCKET_URL &&
  !import.meta.env.VITE_API_WEBSOCKET
) {
  // This will show up in the browser console in dev builds
  // and is handy to catch misconfigured env files.
  // eslint-disable-next-line no-console
  console.warn(
    '[WebSocket] No VITE_WEBSOCKET_URL / VITE_API_WEBSOCKET set, ' +
      `falling back to ${FALLBACK_DEV_URL}`,
  );
}
